<div class="row">
  <div class="col-12">
    <div class="card overflow-hidden">
      <div class="bg-opacity-10 bg-primary">
        <div class="row">
          <div class="col">
            <div class="text-primary px-4 py-3">
              <h3 class="text-primary mb-1">
                <a [routerLink]="[details]">
                  {{ resident.name }}
                </a>
              </h3>
              <p>Prefers to be called {{ resident.profile?.preferredName }}</p>
            </div>
          </div>
          <div class="col-auto">
            <div class="p-3">
              <div
                class="row justify-content-end mb-3"
                *ngIf="resident.residentAppInstalled || resident.webAppUserInd">
                <div class="col-auto">
                  <h6
                    *ngIf="resident.residentAppInstalled"
                    class="d-flex justify-content-center align-items-center m-0">
                    <i
                      class="bx bx-check-circle font-size-20 text-primary me-1"></i>
                    Mobile App
                  </h6>
                </div>
                <div class="col-auto">
                  <h6
                    *ngIf="resident.webAppUserInd"
                    class="d-flex justify-content-center align-items-center m-0">
                    <i
                      class="bx bx-check-circle font-size-20 text-primary me-1"></i>
                    Web App
                  </h6>
                </div>
              </div>

              <div class="row g-2">
                <div class="col">
                  <div class="d-flex flex-column gap-2">
                    <a
                      [routerLink]="['app-card']"
                      class="btn btn-sm btn-outline-primary w-xl">
                      <i class="bx bx-printer"></i>
                      Print App Card
                    </a>

                    <button
                      *ngIf="
                        community.corporation.id === environment.trilogyCorpId
                      "
                      class="btn btn-sm btn-outline-info w-xl"
                      (click)="residentSnapshot()">
                      Resident Snapshot
                    </button>

                    <a
                      *ngIf="
                        {
                          flags: community?.corporation?.flags,
                          key: 'STORY_FEATURE'
                        } | corporationFlags
                      "
                      [routerLink]="[landing]"
                      class="btn btn-sm btn-primary mb-2 w-xl"
                      target="_blank">
                      View Stories
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
                <div class="col">
                  <div class="d-flex flex-column gap-2">
                    <button
                      class="btn btn-sm btn-primary w-xl"
                      (click)="resetMobileAppPassword()">
                      Reset Password
                    </button>

                    <a
                      *ngIf="
                        {
                          flags: community?.corporation?.flags,
                          key: 'STORY_FEATURE'
                        } | corporationFlags
                      "
                      [routerLink]="[stories]"
                      class="btn btn-primary btn-sm w-xl">
                      Edit Stories
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </a>

                    <button
                      *ngIf="
                        community.corporation.id !== environment.brookdaleCorpId
                      "
                      class="btn btn-sm btn-info w-xl"
                      (click)="engagementPlan()">
                      Engagement Plan
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body pt-0">
        <div class="row">
          <div class="col-md-2">
            <div class="profile-user-wid">
              <app-images
                [src]="resident.profile?.media?.url ?? ''"
                [class]="'img-thumbnail rounded-circle'"
                alt="{{ resident.name }}"></app-images>
            </div>

            <a [routerLink]="[edit]" class="btn btn-light btn-md w-100 mt-3">
              Edit
            </a>
          </div>

          <div class="col-md-10">
            <div class="py-4 border-bottom">
              <div class="row">
                <div class="col">
                  <h6>Apartment</h6>
                  <p>{{ resident.profile?.roomNumber }}</p>
                </div>
                <div class="col">
                  <h6>Care Level</h6>
                  <p>{{ resident.careType?.name }}</p>
                </div>
                <div class="col">
                  <h6>Family App Code</h6>
                  <p>{{ resident.profile?.code }}</p>
                  <button
                    *ngIf="resident.profile?.code"
                    class="btn btn-sm btn-light"
                    (click)="copy(resident.profile?.code)">
                    <i class="bx bx-copy align-middle"></i>
                    Copy
                  </button>
                </div>
                <div class="col">
                  <h6>Resident App Code</h6>
                  <p>{{ resident.profile?.residentCode }}</p>
                  <button
                    *ngIf="resident.profile?.residentCode"
                    class="btn btn-sm btn-light"
                    (click)="copy(resident.profile?.residentCode)">
                    <i class="bx bx-copy align-middle"></i>
                    Copy
                  </button>
                </div>
                <div class="col">
                  <h6>Email</h6>
                  <p class="text-truncate">{{ resident.email }}</p>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-7">
                <div class="px-2">
                  <h4 class="card-title mb-2">About</h4>

                  <p class="text-muted mb-0">
                    {{ resident.profile?.about }}
                  </p>
                </div>
              </div>
              <div class="col-5">
                <div class="px-2">
                  <div class="row">
                    <div class="col-6">
                      <h4 class="card-title mb-2">Interview Status</h4>

                      <p class="text-muted mb-0">
                        <ng-container *ngFor="let flag of resident.flags">
                          <ng-container
                            *ngIf="flag.name === 'INTERVIEW_REFUSED'">
                            {{ flag.value ? 'Refused' : 'Not Refused' }}
                          </ng-container>
                        </ng-container>
                      </p>
                    </div>
                    <div class="col-6">
                      <h4 class="card-title mb-2">Last Interview</h4>
                      <p>
                        {{
                          mm(resident.profile?.lastInterviewDt).format(
                            'MMM DD, YYYY'
                          )
                        }}
                      </p>

                      <h4 class="card-title mb-2">Next Interview</h4>
                      <p>
                        {{
                          mm(resident.profile?.nextInterviewDt).format(
                            'MMM DD, YYYY'
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
